/* global axios */

import ApiClient from './ApiClient';

class SgpAPI extends ApiClient {
  constructor() {
    super('integrations/sgp', { accountScoped: true });
  }

  // Validators / setup
  validateCredentials({ sgp_url, sgp_app, sgp_token }) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/validate_credentials`,
      {
        sgp_url,
        sgp_app,
        sgp_token,
      }
    );
  }

  // Viability
  viabilityByZip(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/viabilidade`,
      payload
    );
  }

  viabilityByCto(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/viabilidade_instalacao`,
      payload
    );
  }

  // Customers
  identifyCustomer(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/clientes/search`,
      payload
    );
  }

  listCustomers(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/clientes/list`,
      payload
    );
  }

  consultaCliente(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/consultacliente`,
      payload
    );
  }

  // Enhanced customer data (with contracts, services, financial data)
  getClienteCompleto(payload) {
    return axios.post(`${this.baseUrl()}/integrations/sgp/clientes/search`, {
      ...payload,
      omitir_contratos: false,
      omitir_titulos: false,
      omitir_contatos: false,
      exibir_conexao: 'true',
      exibir_observacao_cliente: 'true',
      exibir_observacao_servicos: 'true',
    });
  }

  // Tickets / Orders / Finance
  listActiveServiceOrders(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/ocorrencias/list`,
      payload
    );
  }

  listServiceOrders(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/ordens_servico/list`,
      payload
    );
  }

  listOpenTitles(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/titulos/list`,
      payload
    );
  }

  // Contracts
  listContracts(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/contratos/list`,
      payload
    );
  }

  // Connectivity
  verifyAccess(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/verificaacesso`,
      payload
    );
  }

  // Promise release (billing/credit)
  promiseRelease(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/liberacaopromessa`,
      payload
    );
  }

  // Monitoring
  radiusLogs(params = {}) {
    return axios.get(`${this.baseUrl()}/integrations/sgp/radius/log`, {
      params,
    });
  }

  maintenanceList(params = {}) {
    return axios.get(`${this.baseUrl()}/integrations/sgp/manutencao/list`, {
      params,
    });
  }

  // Pre-registration helpers
  listPrePlans(payload = {}) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/precadastro_plans`,
      payload
    );
  }

  listPreDueDates(payload = {}) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/precadastro_due_dates`,
      payload
    );
  }

  listPreVendors(payload = {}) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/precadastro_vendors`,
      payload
    );
  }

  createPrePF(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/precadastro_pf`,
      payload
    );
  }

  createPrePJ(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/precadastro_pj`,
      payload
    );
  }

  // Contact data application (F3)
  applyToContact(payload) {
    return axios.post(
      `${this.baseUrl()}/integrations/sgp/apply_to_contact`,
      payload
    );
  }

  // CEP lookup (local service)
  cepLookup(cep, params = {}) {
    return axios.get(`${this.baseUrl()}/integrations/sgp/cep/${cep}`, {
      params,
    });
  }

  cepSearch(params = {}) {
    return axios.get(`${this.baseUrl()}/integrations/sgp/cep/search`, {
      params,
    });
  }

  cepAutocomplete(params = {}) {
    return axios.get(`${this.baseUrl()}/integrations/sgp/cep/autocomplete`, {
      params,
    });
  }

  cepReverse(params = {}) {
    return axios.get(`${this.baseUrl()}/integrations/sgp/cep/reverse`, {
      params,
    });
  }
}

export default new SgpAPI();
